import { atom } from "recoil";

// カレンダーのCourceItem巡回開催日時
export const courceItemState = atom({
  key: "courceItemState",
  default: null,
});